import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').HygieneSection}
 */

const HygieneSection = ({
    heading,
    items
}) => {

    return (
        <div className='module-hygiene-section'>
            <div className='module-product-detail-section bg-main-blackground'>
                <div className='layout-container layout-site-outer-padding py-16 sm:py-40 md:py-48'>
                    <div className='flex gap-y-32 flex-col md:flex-row col-wrapper'>
                        <div className='md:w-4/12 col-padding'>
                            {heading && (
                                <h2 className='type-style-2'>{heading}</h2>
                            )}
                        </div>
                        <div className='flex flex-col gap-y-48 md:w-5/12 col-padding pt-10'>
                            {items?.map((section, sectionIndex) => (
                                <div
                                    className='flex flex-col gap-y-24'
                                    key={`section-${sectionIndex}`} >
                                    {section.heading && (
                                        <h3 className='type-style-3'>{section.heading}</h3>
                                    )}
                                    {section.items?.length > 0 && (
                                        <div>
                                            {section.items.map((item, itemIndex) => (
                                                <div
                                                    className='border-t border-main-border py-16 type-style-body-r'
                                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                                    key={`item-${sectionIndex}-${itemIndex}`}/>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HygieneSection;
